<template>
    <v-dialog v-model="dialog" max-width="900" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Equipment relationship'|translate }}
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pr-4 pl-4">
                <v-text-field :label="'Type'|translate" v-model="type"></v-text-field>
                <equipment-selector :label="'Equipment 1'|translate" v-model="equip1"></equipment-selector>
                <v-switch color="success" v-model="addMultiple" class="pa-0 ma-0 pt-3"  v-if="!equipment_relationship_id"
                          :label="'Multiple Child Equipments'|translate"></v-switch>
                <equipment-selector :label="'Equipment 2'|translate" v-model="equip2" v-if="!addMultiple"></equipment-selector>
                <v-autocomplete v-if="addMultiple" clearable v-model="addMultipleType" :label="'Equipment Type filter'|translate" :items="equipTypeFilterOptions"></v-autocomplete>
                <v-treeview v-if="addMultiple&&addMultipleType"
                            v-model="addMultipleSelected"
                            :items="equipTree"
                            activatable
                            open-on-click
                            selected-color="success"
                            selectable
                >
                </v-treeview>
            </v-card-text>
            <v-card-actions>
                <v-btn class="primary" @click="deleteItem()" :disabled="!$can('update', 'Equipment')" v-if="equipment_relationship_id">
                    <v-icon small class="mr-2">fa-trash </v-icon>{{ 'Delete'|translate }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'Equipment')||!type||type===''||(!addMultiple&&!equip2)||(addMultiple&&(!addMultipleType||!addMultipleSelected||addMultipleSelected.length===0))" v-if="!addLoading">
                    {{ 'Save'|translate }}
                </v-btn>
                <v-btn @click="initializeVar(true)" v-if="!addLoading">{{ 'Cancel'|translate }}</v-btn>
                <v-progress-circular :indeterminate="true" size="20" v-if="addLoading"></v-progress-circular>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {putEquipmentRelationship, deleteEquipmentRelationship, sortFloors} from '../helper'
import EquipmentSelector from "./EquipmentSelector";

export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null},
        existingRelationships: {type: Array, default: null},
    },
    components: {EquipmentSelector},
    computed: {
        equipTypeFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(Object.values(this.$store.state.pointsListStore.pointsList.equipment_details).filter(x=>x.equipment_type).map(x=>x.equipment_type))])).sort()
        },
        equipFloorFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(Object.values(this.$store.state.pointsListStore.pointsList.equipment_details).filter(x=>x.floor).map(x=>x.floor))])).sort()
        },
        equipTree() {
            let equipList = JSON.parse(JSON.stringify(Object.values(this.$store.state.pointsListStore.pointsList.equipment_details))).filter(x => x.equipment_type===this.addMultipleType)
            equipList.sort((a, b) => (a.equipment_name > b.equipment_name) ? 1 : -1)
            let equipPaths = [];
            for (let equip of equipList) {
                let newPath=[]
                if(equip.floor&&equip.floor!==""&&equip.floor!=="NaN"){
                    if (equip.floor.startsWith(".")&&this.$store.state.userStore.user.content.role!=="admin"){
                        continue
                    }
                    newPath=equip.floor.split('>').concat([equip.equipment_name])
                } else if (equip.equipment_type&&equip.equipment_type!==""&&equip.equipment_type!==equip.equipment_name){
                    newPath=[equip.equipment_type,equip.equipment_name]
                } else {
                    newPath=[equip.equipment_name]
                }
                newPath.unshift("ALL")
                if(newPath.length>1){
                    for (let index=0; index<newPath.length; index++){
                        if(index<newPath.length&&newPath[index]===newPath[index+1]){
                            newPath[index]=newPath[index]+" "
                        }
                    }
                }
                equipPaths.push(newPath)
            }
            equipPaths = sortFloors(equipPaths)
            return this.arrangeIntoTree(equipPaths);
        },

    },
    name: 'EquipmentRelationshipDialog',
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                let newItem=JSON.parse(JSON.stringify(item))
                this.equipment_relationship_id = newItem['equipment_relationship_id']
                this.type = newItem['type']
                this.equip1 = this.nameMap[newItem['equip1']]
                this.equip2 = this.nameMap[newItem['equip2']]
            }
        },
        value() {
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dialog: false,
            equipment_relationship_id: null,
            type: null,
            equip1: null,
            equip2: null,
            addMultiple:false,
            addMultipleSelected:[],
            addMultipleType:null,
            addLoading:false,
            nameMap:{},
        }
    },
    mounted() {
        let newMappings={}
        for (let equip of Object.values(this.$store.state.pointsListStore.pointsList.equipment_details)){
            newMappings[equip.equipment_id]=equip.equipment_name
        }
        this.nameMap=newMappings
    },
    methods: {
        findWhere(array, key, value) {
            let t = 0;
            while (t < array.length && array[t][key] !== value) {
                t++;
            }
            if (t < array.length) {
                return array[t]
            } else {
                return false;
            }
        },
        arrangeIntoTree(paths) {
            let tree = [];
            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];
                let currentLevel = tree;
                for (let j = 0; j < path.length; j++) {
                    let part = path[j];
                    let existingPath = this.findWhere(currentLevel, 'name', part);
                    if (existingPath) {
                        currentLevel = existingPath.children;
                    } else {
                        let newPart = {
                            name: part,
                            id: path.join('-') + '-' + part,
                            floor: path.slice(0, j + 1).join('>'),
                            children: [],
                        }
                        currentLevel.push(newPart);
                        currentLevel = newPart.children;
                    }
                }
            }
            return tree;
        },
        initializeVar(close=false) {
            this.equipment_relationship_id = null
            this.type = null
            this.equip1 = null
            this.equip2 = null
            this.addLoading=false
            this.addMultiple=false
            this.addMultipleType=null
            this.addMultipleSelected=[]
            if (close) {
                this.dialog = false
            }
        },
        async addRecord() {
            this.addLoading=true
            if (this.addMultiple){
                let currentId=this.$store.state.pointsListStore.pointsList.equipment_details[this.equip1].equipment_id
                let allEquip=Object.values(this.$store.state.pointsListStore.pointsList.equipment_details).filter(x=>x.equipment_type===this.addMultipleType)
                if (this.addMultipleSelected&&this.addMultipleSelected.length>0){
                    let nameFilter=this.addMultipleSelected.map(x=>x.split("-")[x.split("-").length-1])
                    allEquip=allEquip.filter(x=>nameFilter.includes(x.equipment_name))
                }
                for (let equip of allEquip){
                    if (equip.equipment_id!==currentId&&this.existingRelationships.filter(x=>x.type===this.type&&x.equip1===currentId&&x.equip2===equip.equipment_id).length===0){
                        await putEquipmentRelationship(
                            {
                                'equipment_relationship_id': this.equipment_relationship_id,
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'type': this.type,
                                'equip1': currentId,
                                'equip2': equip.equipment_id,
                            }
                        )
                    }
                }
            } else {
                await putEquipmentRelationship(
                    {
                        'equipment_relationship_id': this.equipment_relationship_id,
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'type': this.type,
                        'equip1': this.$store.state.pointsListStore.pointsList.equipment_details[this.equip1].equipment_id,
                        'equip2': this.$store.state.pointsListStore.pointsList.equipment_details[this.equip2].equipment_id,
                    }
                )
            }
            this.addLoading=false
            this.$emit('doreload')
            this.initializeVar(true)
        },
        async deleteItem() {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteEquipmentRelationship({
                    'equipment_relationship_id': this.equipment_relationship_id
                })
                this.$emit('doreload')
                this.dialog = false
            }
        },
    },
}
</script>

<style scoped>

</style>
